import { DIRECT_UPLOAD_ACTIONS, initialDirectUploadState } from './directUpload.types';
export function directUploadReducer(state = initialDirectUploadState, action) {
    switch (action.type) {
        case DIRECT_UPLOAD_ACTIONS.SET_UPLOAD:
            return {
                ...state,
                uploads: {
                    ...state.uploads,
                    [action.key]: { ...state.uploads[action.key], ...action.payload }
                }
            };
        case DIRECT_UPLOAD_ACTIONS.SET_PROGRESS:
            return {
                ...state,
                uploads: {
                    ...state.uploads,
                    [action.key]: { ...state.uploads[action.key], progress: action.progress }
                }
            };
        case DIRECT_UPLOAD_ACTIONS.SET_ERROR:
            return {
                ...state,
                uploads: {
                    ...state.uploads,
                    [action.key]: { ...state.uploads[action.key], error: action.error, status: 'failed' }
                }
            };
        case DIRECT_UPLOAD_ACTIONS.REMOVE_UPLOAD: {
            const { [action.key]: _, ...remaining } = state.uploads;
            return { ...state, uploads: remaining };
        }
        case DIRECT_UPLOAD_ACTIONS.CLEAR_ALL:
            return initialDirectUploadState;
        default:
            return state;
    }
}
